import $ from 'jquery'
import 'bootstrap'

let BModal = $.fn.modal.Constructor.prototype

// to allow focus {pos:absolute} elements while modal is opened
// eslint-disable-next-line no-unused-vars
let originalEnforceFocus = BModal.enforceFocus
BModal.enforceFocus      = function () {}

// modal fix: 'modal-open' class on body if multiple modals opened
BModal.modalsOpenedAmount = 0

BModal.showOriginal = BModal.show
BModal.show         = function (_relatedTarget) {
  if (this.isShown) return

  this.modalsOpenedAmount++

  this.showOriginal(_relatedTarget)
}

BModal.hideModalOriginal = BModal.hideModal
BModal.hideModal         = function () {
  this.modalsOpenedAmount--

  this.$element.hide()
  this.backdrop(() => {
    if (this.modalsOpenedAmount === 0) this.$body.removeClass('modal-open')
    this.resetAdjustments()
    this.resetScrollbar()
    this.$element.trigger('hidden.bs.modal')
  })
}

//
let originalLeave                        = $.fn.popover.Constructor.prototype.leave
$.fn.popover.Constructor.prototype.leave = function (obj) {
  let self = obj instanceof this.constructor ? obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)
  let $container, timeout

  originalLeave.call(this, obj)
  if (self.options.hoverable) {
    if (obj.currentTarget) {
      $container = $('#' + $(obj.currentTarget).attr('aria-describedby'))
      if ($container.length) {
        timeout = self.timeout
        $container.one('mouseenter', function () {
          // We entered the actual popover – call off the dogs
          clearTimeout(timeout)
          // Let's monitor popover content instead
          $container.one('mouseleave', function () {
            $.fn.popover.Constructor.prototype.leave.call(self, self)
          })
        })
      }
    }
  }
}
